import { readExplorerStrip, ROUTER_PARAM } from "./routeModel.js";
import { caseCanvasId, openCaseCanvas, saveTraceCanvas } from "./traceCanvasStore.js";
import { showWorkspaceInDeck } from "./deckRequests.js";

export function triageScopeToken(params) {
    const own = params.get(ROUTER_PARAM.TRIAGE_SCOPE);
    if (own !== null) return own;
    if (params.get("view") !== "scope.reviews") return "";
    const strip = readExplorerStrip(params);
    const active = strip.tabs[strip.activeIdx];
    return active?.kind === "scope" ? active.payload : "";
}

export function triageJobFor(findings, id) {
    if (!id) return null;
    return (findings || []).find((job) => job.id === id || (job.findings || []).some((finding) => finding.id === id)) || null;
}

export function openTriageWorkspace(job, verdicts = {}) {
    if (!job?.id || !job.session) throw new Error("This finding has no session to investigate.");
    const members = job.findings?.length ? job.findings : [job];
    const text = members.map((finding) => {
        const verdict = verdicts[finding.id];
        return [finding.title || "Flagged finding", verdict?.correctedClaim, verdict?.standardWhy || verdict?.why].filter(Boolean).join("\n");
    }).join("\n\n");
    const id = openCaseCanvas({
        id: caseCanvasId("triage", job.id),
        title: job.title || "Finding investigation",
        anchor: job.session,
        sessions: [{ id: job.session }],
        findings: members.map((finding) => ({ id: finding.id, session: finding.session || job.session, title: finding.title || "" })),
        account: { id: "triage-context", text },
        open: false,
    });
    if (!id) throw new Error("Could not open this finding in an investigation. Try again.");
    saveTraceCanvas(id);
    const message = members.flatMap((finding) => finding.messages || [])[0];
    showWorkspaceInDeck(id, message ? { focus: job.session + "#" + message } : null);
    return id;
}
